$(document).ready(function () {
    if ( !$('body.in-sitecore').length ) {
        $( "h2.aircraftDetailSectionTitle" ).click( function(){
            $( this ).toggleClass("is-open");
        });
    }
});